<template>
    <el-row :gutter="30"  class="mw-100 manage-service" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentServiceData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addServiceRef"
                            :model="currentServiceData"
                            :rules="currentServiceDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="manageService('addServiceRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-row :gutter="30">
                                        <el-col :lg="3" :xs="24">
                                            <el-form-item  label="service order" prop="seq">
                                                <el-input type="text" v-model="currentServiceData.seq"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :xs="24">
                                            <el-form-item  label="service image" prop="imageBase64">
                                                <el-image 
                                                    style="width: 150px; height: 150px;margin-right:20px" 
                                                    :src="isAddService ? currentServiceData.imageURL :  $getImage(currentServiceData.imageURL) || ''" 
                                                    fit="cover"
                                                    :zoom-rate="1.2"
                                                    :preview-src-list="[isAddService ? currentServiceData.imageURL : $getImage(currentServiceData.imageURL)]"
                                                    :preview-teleported="true"
                                                >
                                                    <template #error>
                                                        <div class="image-slot">
                                                            <font-awesome-icon :icon="['fas', 'image']" />
                                                        </div>
                                                    </template>
                                                </el-image>
                                                <el-upload
                                                    ref="imageBase64"
                                                    action="#"
                                                    :auto-upload="false"
                                                    :on-change="onUploadImage"
                                                    :disabled="fileUploaded"
                                                    :on-remove="handleRemoveImage"
                                                    accept="image/png, image/jpeg,image/gif"
                                                    class="font-24 d-flex align-center flex-1"
                                                >
                                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                                </el-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :lg="12" :xs="24">
                                    <el-card class="h-100">
                                        <el-row :gutter="30">
                                            <el-col :lg="24" :xs="24">
                                                <h3>Service Page Data</h3>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="title" :prop="`extendedTranslates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="text" v-model="currentServiceData.extendedTranslates[index].title"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="description" :prop="`extendedTranslates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <!-- <el-input type="textarea" rows="4" v-model="currentServiceData.extendedTranslates[index].description"></el-input>     -->
                                                    <ckeditor class="w-100" :editor="editor" v-model="currentServiceData.extendedTranslates[index].description" :config="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? editorConfigAr :editorConfig "></ckeditor>  
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-col>
                                <el-col :lg="12" :xs="24">
                                    <el-card class="h-100">
                                        <el-row :gutter="30">
                                            <el-col :lg="24" :xs="24">
                                                <h3>Home Page Data</h3>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="text" v-model="currentServiceData.translates[index].title"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="textarea" rows="9" v-model="currentServiceData.translates[index].description"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-col>
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    <el-dialog v-model="dialogVisible" width="30%">
        <img w-full :src="dialogImageUrl" alt="Preview Image" class="w-100" />
    </el-dialog>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data(){
        return {
            currentPage:[],
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
               
                // The configuration of the editor.
            },
            editorConfigAr: {
                language: {
                    // The UI will be English.
                    ui: 'ar',

                    // But the content will be edited in Arabic.
                    content: 'ar'
                }
            },
            fileList:[],
            isAddService:true,
            dialogVisible:false,
            dialogImageUrl:'',
            currentService:[],
            fileUploaded:false,
            currentServiceData:{},
            currentServiceDataRules:{
                seq:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['description','title']),
                extendedTranslates:this.$setTranslateRules(['description','title']),
            }
        };
    },
    computed:{
        cachedService(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.services?.currentService || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedService.id) {
            this.isAddService = false;
            this.currentServiceData = JSON.parse(JSON.stringify(this.cachedService));
            this.currentServiceData = this.converUpdatedObj(this.currentServiceData);
            this.currentServiceData.translates = this.$filterPublishedTranslates(this.currentServiceData.translates);
            this.currentServiceData.extendedTranslates = this.$filterPublishedTranslates(this.currentServiceData.extendedTranslates);
            this.currentServiceData.active = true;
           
        }else{
            this.$router.push({
                name:'manage-service',
            })
            this.isAddService = true;
            this.currentServiceData = this.initState()
            this.currentServiceDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
             
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                }),
                extendedTranslates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                })
            }
        },

        async manageService(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addServiceRef'].length){
                            this.manageServiceAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageServiceAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentServiceData));
            delete clonedData.imageURL;
            
            
            const response = await this.$store.dispatch(this.isAddService ? 'addService':'editService',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllServices');
                this.$router.push({
                    name:'services-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentServiceData.imageBase64 = evt.target.result;
                }); 
                this.currentServiceData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        }, 
        handleRemoveImage(){
            this.currentServiceData.imageURL = this.isAddService ? '' : this.cachedService.imageURL
        },   
        handlePictureCardPreview(file){
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;

        },
        handleRemove(file){
            let imageIndexFromSubITems;
            if(file.name  == 'oldItem') {
                imageIndexFromSubITems = this.currentServiceData.subItems.findIndex(img => img.id == file.uid);
                this.currentServiceData.subItems[imageIndexFromSubITems].active = false;
                this.currentServiceData.subItems[imageIndexFromSubITems].uid = file.uid;
            }else{
                imageIndexFromSubITems = this.currentServiceData.subItems.findIndex(img => img.uid == file.uid);
                this.currentServiceData.subItems.splice(imageIndexFromSubITems,1);
            }
        },
        onUploadBrand(file){
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentServiceData.subItems.push({
                    imageBase64:evt.target.result,
                    seq:0,
                    uid:file.uid,
                    id:-1,
                });
            }); 
            // this.currentServiceData.imageURL =  URL.createObjectURL(file.raw);

            FR.readAsDataURL(file.raw);
        },
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
            
        }
    }
}
</script>
<style lang="scss">
    .manage-service {
        .ck-editor {
            width:100%;
        }
    }
</style>